export default "__VITE_ASSET__CnyPfHo2__"